// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"palace-3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10H21V21H3V10H7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M11.998 8.99805H12.002V9.00195H11.998V8.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 4C14.7614 4 17 6.23858 17 9V10H21V21H3V10H7V9C7 6.23858 9.23858 4 12 4ZM12 4L12.002 3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-palace-3')
export default class Palace3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'palace-3',
    }
  }
}
